import { DataGridDollarValue } from "~/components/DataGrid/DataGridDollarValue";
import { CountryData } from "./types";
import { RWA_COIN_ICON } from "~/consts";

// // // //

export function MapTooltip(props: { country: CountryData }) {
    const c = props.country;
    return (
        <div className="p-1.5">
            <div className="flex items-center gap-2">
                <img
                    src={c.icon_url ?? RWA_COIN_ICON}
                    alt={`${c.name} Flag`}
                    className="rounded-xs h-4 shadow-lg"
                />
                <p
                    className="text-base font-sans font-normal"
                    style={{ fontSize: "1rem" }}
                >
                    {c.name}
                </p>
            </div>
            <table className="mt-1 w-full" style={{ fontSize: ".875rem" }}>
                <tbody>
                    <tr>
                        <td className="text-left leading-normal">
                            Real Estate Assets
                        </td>
                        <td className="text-right leading-normal tabular-nums">
                            {c.asset_count.toLocaleString()}
                        </td>
                    </tr>
                    <tr>
                        <td className="text-left leading-normal">
                            Total Value
                        </td>
                        <td className="text-right leading-normal flex items-center justify-end tabular-nums">
                            <DataGridDollarValue value={c.value} />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
